import * as React from "react";
const SvgChevronLeft24 = (props, ref) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", d: "M15.28 4.22a.75.75 0 0 1 0 1.06L8.56 12l6.72 6.72a.75.75 0 1 1-1.06 1.06l-7.25-7.25a.75.75 0 0 1 0-1.06l7.25-7.25a.75.75 0 0 1 1.06 0Z" }));
const ForwardRef = React.forwardRef(SvgChevronLeft24);
export default ForwardRef;
